import script from "./MessageDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./MessageDialog.vue?vue&type=script&lang=ts&setup=true"

import "./MessageDialog.vue?vue&type=style&index=0&id=dbe99d68&lang=less"

const __exports__ = script;

export default __exports__